import React from "react";
import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

export const getIgnoreZoneDialogInfo = (
  row: any,
  setSelectedAlertCameraInfo: any,
  setIgnoreZonesSelectedAlert: any,
  setLoadingIgnoreZonesInfo: Dispatcher<boolean>,
  navigate: NavigateFunction,
  onComplete?: () => void
) => {
  const AxiosUI = createApi(``);

  const retryFunction = () => {
    getIgnoreZoneDialogInfo(
      row,
      setSelectedAlertCameraInfo,
      setIgnoreZonesSelectedAlert,
      setLoadingIgnoreZonesInfo,
      navigate,
      onComplete
    );
  };

  const handleComplete = () => {
    setLoadingIgnoreZonesInfo(false);
    onComplete?.();
  };

  AxiosUI.get(`/camera/${row.camera_pk}/status/`).then(
    (response: AxiosResponse) => {
      setSelectedAlertCameraInfo(response.data);
      AxiosUI.get(`/camera/${row.camera_pk}/ignore_zones/`).then(
        (response: AxiosResponse) => {
          setIgnoreZonesSelectedAlert(response.data);
          handleComplete();
        },
        (reason: AxiosError) => {
          universalAPIErrorHandler(reason, navigate, retryFunction, () => {
            setIgnoreZonesSelectedAlert([]);
            handleComplete();
          });
        }
      );
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setSelectedAlertCameraInfo({});
        handleComplete();
      });
    }
  );
};
